import { useRef, useCallback } from 'react';

export default function usePreventDoubleClick() {
    const isClicked = useRef(false);

    const handleClick = useCallback((callback, delay = 300, useArgs = false) => {
        return (...args) => {
            if (!isClicked.current) {
                isClicked.current = true;
                
                // Выполняем переданную функцию
                if (callback) {
                    if (useArgs) {callback(...args);}
                    else {callback();}
                }
                
                // Автоматическая разблокировка через указанное время
                setTimeout(() => {
                    isClicked.current = false;
                }, delay);
            }
        };
    }, []);

    return handleClick;
}
